module.exports = __webpack_public_path__ + "img/1091656819.2ed60ac8.png";